exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h1{font-size:12pt}h2{font-weight:700}li{margin-left:12px;margin-top:3px;font-size:10pt}.lists-page{display:flex;flex-direction:row;flex-wrap:wrap}.list-wrapper{display:flex;flex-direction:column;padding:10px}.list-wrapper h2{padding:15px;background:#e6e6e6;font-size:1rem}.list-wrapper ul{padding:15px;background:hsla(0,0%,90%,.4)}.list-wrapper li{padding:0;margin:0;margin-bottom:15px;list-style:none}.list-wrapper li:last-child{margin-bottom:0}.list-wrapper li a{color:#000;text-decoration-color:#999}@media only screen and (max-width:768px){.list-wrapper{width:100%}}.list-spinner{transform:scale(.8);margin-left:-4px;margin-top:-4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/Lists/Lists.scss
// module id = 853
// module chunks = 0